module.exports = __webpack_public_path__ + "static/img/echart6.a0bf64fa.png";